import { ApiService } from "@/api";

export const updateAdminQualityStatus = (sampleId: string, status: string) => {
  return ApiService.baseAction(
    `admin-quality/status/${sampleId}`,
    {
      data: {
        status,
      },
    },
    "post"
  );
};
